export const paths = {
  Unsubscribe: () => '/unsubscribe',
}
